(function trackSourceURL(global) {
  'use strict';

  global.NewHomeSource = global.NewHomeSource || {};

  /**
   * @private
   * getSourceURL: gets the source URL before the 404 error.
   * @param {string} url source URL.
   */
  function getSourceURL(url) {
    const sourceURL = document.querySelector(url);

    return sourceURL.value;
  }

  /**
   * @private
   * deleteCookie: deletes cookie.
   * @param {string} cookieName cookie name to be deleted.
   */
  function deleteCookie(cookieName) {
    global.NewHomeSource.Modules.cookieHandler.eraseCookie(cookieName, true);
  }

  /**
   * @private
   * trackPageNotFoundEvents: track the events from the mvc error page.
   */
  function trackPageNotFoundEvents() {
    const eventGa4 = {
      eventName: 'page_not_found',
      params: {
        sourceUrl: getSourceURL('[data-source-url]')
      },
      eventType: 'GA4Event'
    };
    document.body.dispatchEvent(new CustomEvent('trackOnDemandEvent', {
      detail: { data: eventGa4 }
    }));
    deleteCookie('SourceURL');
  }

  window.addEventListener('load', trackPageNotFoundEvents);
}(window));
